'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { createRef, Component } from 'react';
import withPauseAndHelpLogic from '../higherOrderComponents/withPauseAndHelpLogic';
import vidyardApiFacade from '../utils/vidyardApiFacade';

var VidyardVideoPlayer = /*#__PURE__*/function (_Component) {
  _inherits(VidyardVideoPlayer, _Component);

  function VidyardVideoPlayer(props) {
    var _this;

    _classCallCheck(this, VidyardVideoPlayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VidyardVideoPlayer).call(this, props));

    _this.onPlayerReady = function () {
      var _this$props = _this.props,
          cancelHelpTextTimeout = _this$props.cancelHelpTextTimeout,
          captionsOnByDefault = _this$props.captionsOnByDefault,
          onReady = _this$props.onReady;
      cancelHelpTextTimeout();

      _this.bindVideoEvents(_this.video);

      if (captionsOnByDefault) {
        _this.video.enableCaption();
      }

      if (onReady) {
        onReady();
      }
    };

    _this.bindVideoEvents = function (video) {
      var _this$props2 = _this.props,
          onPlay = _this$props2.onPlay,
          onFinish = _this$props2.onFinish,
          onPause = _this$props2.onPause,
          onUpdateProgress = _this$props2.onUpdateProgress;

      if (onPlay) {
        video.bind('play', onPlay);
      }

      if (onPause) {
        video.bind('pause', onPause);
      }

      if (onFinish) {
        video.bind('playerComplete', onFinish);
      }

      if (onUpdateProgress) {
        video.bind('timeupdate', function (seconds) {
          if (!_this.state.hasMarkedProgress && seconds > 10) {
            _this.setState({
              hasMarkedProgress: true
            });

            onUpdateProgress();
          }
        });
      }
    };

    _this.state = {
      hasMarkedProgress: false
    };
    _this.container = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(VidyardVideoPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initVideoPlayer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.videoId !== this.props.videoId) {
        prevProps.cancelHelpTextTimeout(); // Tear down the player and set up a new one.

        this.video.destroy();
        prevProps.onChangeVideo();
        this.setState({
          hasMarkedProgress: false
        });
        this.initVideoPlayer();
      } else if (prevProps.videoPlaySpeed !== this.props.videoPlaySpeed) {
        this.video.setPlaybackSpeed(this.props.videoPlaySpeed / 100);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.video.destroy();
    }
  }, {
    key: "initVideoPlayer",
    value: function initVideoPlayer() {
      var _this$props3 = this.props,
          videoId = _this$props3.videoId,
          startHelpTextTimeout = _this$props3.startHelpTextTimeout;
      startHelpTextTimeout();
      this.video = vidyardApiFacade(Object.assign({}, this.getOptionsFromProps(), {
        container: this.container.current,
        uuid: videoId
      }));
      this.video.onReady(this.onPlayerReady);
    }
  }, {
    key: "getOptionsFromProps",
    value: function getOptionsFromProps() {
      var _this$props4 = this.props,
          color = _this$props4.color,
          autoPlay = _this$props4.autoPlay,
          enableEmbed = _this$props4.enableEmbed,
          enableSharing = _this$props4.enableSharing,
          videoPlaySpeed = _this$props4.videoPlaySpeed,
          preload = _this$props4.preload;
      var colorCode = color && color.replace('#', '');
      return {
        autoplay: autoPlay ? '1' : '0',
        color: colorCode,
        embed_button: enableSharing ? 1 : 0,
        play_button_color: colorCode,
        preload: preload || 'metadata',
        speed: videoPlaySpeed / 100,
        viral_sharing: enableEmbed ? 1 : 0
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        ref: this.container
      });
    }
  }]);

  return VidyardVideoPlayer;
}(Component);

VidyardVideoPlayer.propTypes = {
  autoPlay: PropTypes.bool,
  cancelHelpTextTimeout: PropTypes.func.isRequired,
  captionsOnByDefault: PropTypes.bool,
  color: PropTypes.string,
  enableEmbed: PropTypes.bool,
  enableSharing: PropTypes.bool,
  preload: PropTypes.string,
  onFinish: PropTypes.func,
  onPause: PropTypes.func,
  onPlay: PropTypes.func,
  onReady: PropTypes.func,
  onChangeVideo: PropTypes.func,
  onUpdateProgress: PropTypes.func,
  startHelpTextTimeout: PropTypes.func.isRequired,
  videoId: PropTypes.string.isRequired,
  videoPlaySpeed: PropTypes.number
};
export default withPauseAndHelpLogic(VidyardVideoPlayer);